export enum Platform {
  ANDROID = 'ANDROID',
  WINDOWS = 'WINDOWS',
}
